const BucketHelper = {
    /**
     * Gets the bucket URL for the specified image.
     * @param {string} bucketUrl The bucket server URL.
     * @param {string} image The image path.
     * @param {number} height The image height.
     * @param {number} width The image width.
     * @param {string} extension The image extension.
     * @returns {string} The image URL.
     */
    GetUrl(bucketUrl, image, height = '', width = '', extension = 'png') {
        let indexOfFotos = image.indexOf('fotos');

        if (indexOfFotos !== -1) {
            const indexFrom = indexOfFotos + 9;
            const indexTo = image.length - 4;

            extension = image.substr(image.length - 3);
            image = image.substr(indexFrom, indexTo - indexFrom);
        }

        if (height !== '') {
            height = `h${height}`;
        }

        if (width !== '') {
            width = `w${width}`;
        }

        const imageFolder = _getImageFolder(image);
        const bucketServerKey = _getBucketServerKey(imageFolder);
        const bucketServer = _getBucketServer(bucketServerKey);

        return `${bucketUrl.replace("{nro}", bucketServer)}/anexos/fotos/${imageFolder}/${image}${width}${height}.${extension}`;
    }
};

function _getImageFolder(image) {
    return image.substr(image.length - 2);
}

function _getBucketServerKey(imageFolder) {
    return imageFolder.substr(imageFolder.length - 1);
}

function _getBucketServer(key) {
    switch (key) {
        case '0':
        case '1':
        case '2':
            return '1';
        case '3':
        case '4':
        case '5':
            return '2';
        default:
            return '3';
    }
}

export default BucketHelper;


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Bucket/BucketHelper.js